/**
 * Normalize a Universal-components spacing dropdown value
 * ('Default' | 'none' | '1'..'4') to a class suffix; 'Default' (and empty)
 * yield null so the component's base value applies.
 */
export function spacing(value?: string | null): string | null {
  if (!value) return null;
  const v = value.toLowerCase();
  return v === 'default' ? null : v;
}
